import React from 'react'
import { Globe, LockKeyhole, Users } from 'lucide-react'
import { homePrivateEnabled } from 'lib/homePrivate'
import Tabs from './Tabs'
import styles from './filter-tabs.module.scss'

export default function FilterTabs({ activeTab, onTabChange, showOnlyFollowing, isLoggedIn }) {
    if (showOnlyFollowing) {
        return (
            <Tabs
                activeTab="following"
                onTabChange={onTabChange}
                tabs={[
                    {
                        key: 'following',
                        label: 'Following',
                        renderIcon: () => <Users size={20} className={styles.followingIcon} />,
                    },
                ]}
            />
        )
    }

    const tabs = [
        {
            key: 'all',
            label: 'Public',
            // The globe in Bitcoin orange, the same size as Following's glyph.
            renderIcon: () => <Globe size={20} className={styles.followingIcon} />,
            onSelect: () =>
                window.logEv('CLICK_PUBLIC_TAB', {
                    previous_tab: activeTab,
                    from_location: 'filter_tabs',
                }),
        },
        ...(isLoggedIn
            ? [
                  {
                      key: 'following',
                      label: 'Following',
                      renderIcon: () => <Users size={20} className={styles.followingIcon} />,
                      onSelect: () =>
                          window.logEv('CLICK_FOLLOWING_TAB', {
                              previous_tab: activeTab,
                              from_location: 'filter_tabs',
                          }),
                  },
              ]
            : []),
        ...(isLoggedIn && homePrivateEnabled()
            ? [
                  {
                      key: 'private',
                      label: 'Private',
                      icon: LockKeyhole,
                      onSelect: () =>
                          window.logEv('CLICK_PRIVATE_TAB', {
                              previous_tab: activeTab,
                              from_location: 'filter_tabs',
                          }),
                  },
              ]
            : []),
    ]

    return <Tabs activeTab={activeTab} onTabChange={onTabChange} tabs={tabs} />
}
